import { CssSizeVariables, ThemingParameters } from '@ui5/webcomponents-react-base';
import React from 'react';
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles({
  title: {
    gridColumn: '1 / span 12',
    display: 'flex',
    alignItems: 'center',
    height: CssSizeVariables.ui5WcrFormGroupTitleHeight,
    lineHeight: CssSizeVariables.ui5WcrFormGroupTitleHeight,
    fontFamily: ThemingParameters.sapFontHeaderFamily,
    color: ThemingParameters.sapGroup_TitleTextColor,
    fontSize: ThemingParameters.sapFontHeader6Size,
    fontWeight: 'bold',
    margin: 0,
    marginBlockStart: '1rem'
  }
}, {
  name: 'FormGroupTitle'
});
export function FormGroupTitle({
  titleText,
  style
}) {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("h6", {
    className: classes.title,
    title: titleText,
    "aria-label": titleText,
    "data-component-name": "FormGroupTitle",
    style: style
  }, titleText);
}